import { getUserInfo } from "shared/utils/getUserInfo";

export const devLog = (...args: any[]) => {
  if (getUserInfo()?.isDeveloper) {
    // eslint-disable-next-line no-console
    console.log("[DEV]:", ...args);
  }
};
